import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../services/general.service';

@Component({
  selector: 'app-instagram',
  templateUrl: './instagram.component.html',
  styleUrls: ['./instagram.component.scss']
})
export class InstagramComponent implements OnInit {

  constructor(private generalService : GeneralService) { }
  enregistrementTerminer = true
  initDoc
  doc;
  listeImages = []
  File_Lien;
  File_Content = "assets/icon.png";
  selectedImage
  ngOnInit() 
  {
    this.getInitDoc()
    this.getListeImage()
  }

  getInitDoc()
  {
    this.generalService.rechercheTable(this.generalService.urlAvtDoc).subscribe(data =>
    {
      data.files[0].File_Type = "INSTAGRAM"
      this.initDoc = data;
      this.doc = this.initDoc.files[0]
    },
    (e)=>
    {
      this.enregistrementTerminer = true;
    })
  }
  
  importer()
  {
    document.getElementById("input_file").click();
  }
  onChangeImagefile(fileInput)
  {
    var file = fileInput.target.files[0];
    var reader = new FileReader();
    if (file.type.indexOf('image') == 0) 
    {
      reader.onload =  (e) =>
      {
        var image = new Image();
        image.src = reader.result.toString();
        image.onload  = (ev) =>
        {
          this.File_Content = reader.result.toString()
          this.doc.File_Content = reader.result
        }
      }
      reader.readAsDataURL(file);
    }
    else
      this.generalService.dialogSuccess("Veuillez sélectionner une image",false)
  }
  modifier()
  {
    if(this.generalService.isNotEmpty(this.selectedImage && this.selectedImage.File_Id))
    {
      this.enregistrementTerminer = false;
      this.generalService.rechercheTable(this.generalService.urlFiles+"&val=" + this.selectedImage.File_Id).subscribe(data =>
      {
        data.Files[0].File_Content = this.File_Content
        data.Files[0].File_Lien = this.File_Lien;
        this.generalService.enregisterTable(data).subscribe(data =>
        {
          this.generalService.dialogSuccess("Enregistrer",true)
          this.getListeImage()
        })
      })      
    }
    else
      this.generalService.dialogSuccess("Veuillez sélectionner une image",false)

  }
  ajouter()
  {
    if(this.initDoc)
    {
      if(this.File_Lien && this.File_Content)
      {
        this.doc.File_Lien = this.File_Lien;
        this.doc.File_Content = this.File_Content;
        this.enregistrementTerminer = false
        this.generalService.enregisterTable(this.initDoc).subscribe(data =>
        {
          this.generalService.dialogSuccess("Enregistrer",true)
          this.getListeImage()
        })
      }
      else
        this.generalService.dialogSuccess("Veuillez remplir tous les champs",false);
    }
    else
      this.generalService.dialogSuccess("Veuillez patienter pendant le chargement total des donnés",false)
  }
  supprimer()
  {
    this.enregistrementTerminer = false
    var del = this.generalService.supprimer(this.selectedImage.File_Id,"avtFiles")
    if(del)
      del.subscribe(data => 
      {
        this.generalService.dialogSuccess("Supprimer",true)
        this.getListeImage()
      },()=>
      {
        this.enregistrementTerminer = true
      })
    else
      this.enregistrementTerminer = true
  }
  selectImage(img)
  {
    this.selectedImage = img;
    this.File_Content = img.File_Content
    this.File_Lien = img.File_Lien
  }
  getListeImage()
  {
    this.File_Content = "assets/icon.png";
    this.File_Lien = null
    this.listeImages = [];
    this.generalService.rechercheTable(this.generalService.url+ "avtFilesType&param=INSTAGRAM").subscribe( img =>
    {
      this.listeImages = img;     
      this.getImageContent()
    });
  }
  
  getImageContent()
  {
    var compte = this.listeImages.length
    for(let i=0;i< this.listeImages.length;i++)
    {
      this.generalService.rechercheTable(this.generalService.urlFiles+"&val="+ this.listeImages[i].File_Id).subscribe( file =>
      {
        this.listeImages[i].File_Content =file.Files[0].File_Content;
        compte--
        if(compte == 0)
          this.enregistrementTerminer = true;
      },()=>
      {
        compte--
        if(compte == 0)
          this.enregistrementTerminer = true;
      });
    }
  }
}
